<template>
<div class="sezione"  style="padding:0 20px;">
<div class="yo-fixed-top" style="top:132px;z-index:999;">
<div class="row el-container" style="background:#fff;padding:16px 20px;">
   <div class="col s12">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="">
         <el-breadcrumb-item>Centro</el-breadcrumb-item>
         <el-breadcrumb-item>Gestione Utenti</el-breadcrumb-item>
      </el-breadcrumb>
   </div>
</div>
</div>
   <div class="title_h1 yo-color-primary" style="margin-top:30px;">GESTIONE UTENTI</div>

   Di seguito elenchiamo gli utenti abilitati all'inserimento o modifica delle schede per il centro di cui lei è il referente!
   <br />
   Per aggiungere un nuovo utente la preghiamo di cliccare l'icona + che trova qui sotto.
   
   

  <div class="row row-head" style="margin-top:30px;">
    <div class="col s5 yo-align-left">NOMINATIVO</div>
    <div class="col s5 yo-align-left">EMAIL</div>
    <div class="col s2 yo-align-center">
      <div style="" class="yo-button small" @click="contattoAdd()" type="primary" ><i class="material-icons">add</i></div>
    </div>
  </div>

  
  <div  class="row row-table" v-for="(itm, index) in dbData" v-bind:key="index">
    <div class="col s5 yo-align-left">{{itm.cognome}} {{itm.nome}}</div>
    <div class="col s5">{{itm.email}}</div>
    <div class="col s2 yo-align-center">
      <a class="yo-button small" @click="rowDel(itm)" style="color:#2E3C4A;padding-right:10px;"><i class="material-icons">delete_forever</i></a>
      <router-link class="yo-button small" :to="'/contatto-edit/'+itm.id" style="color:#2E3C4A;padding-right:10px;"><i class="material-icons">edit</i></router-link>
      <a class="yo-button small" @click="sendCredenziali(itm)" style="color:#2E3C4A;padding-right:10px;"><i class="material-icons">email</i></a>
    </div>
  </div>




   
</div>
</template>

<script>
import emailContatto from './Email-contatto.vue'

export default {
  components: {
  },
  created () {
  },

destroyed() {
    console.error("ESCO")
},
  data () {
    return {
      rowfilter: {cognome:'',nome:'',citta:'',email:''},
       tbstart:0,
       totxpage: 1000,
       more:0,
       order: 'asc',
       icon: 'el-icon-sort-down',
      rowBanca:[]
       
    }
  },
  computed:{
    dbData:function(){
        var filterData = []
        if(this.$centro._contatto.length>0)
        for(let item of this.$centro._contatto){
            filterData.push(item)    
        } 
        
        return filterData //.sort(this.$teras.compareValues('cognome',this.order)); 
    }
   },
   methods:{
      async sendCredenziali(itm){
         this.loading = this.$loading({lock: true, text: 'Spedizione in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })

         var html = this.$teras.renderVue(emailContatto,{contatto:itm, utente:this.$teras.utente, centro:this.$centro.profile.row})
         this.$axios.email({from:'innsin@biomedia.net',oggetto:'INNSIN – Abilitazione alla compilazione delle schede INNSIN ',to:itm.email,body:html}).then((data) => {
            console.log("Email con invio credenziali inviata")
         }).catch((error) => {
            console.log("Errore nell'invio della email con le credenziali")
            console.log(error)
         })


         this.loading.close()
         this.$notify.success({type: 'info',message: 'Credenziali inviate correttamente', duration:5000}) 
     },
      contattoAdd () {
         this.$router.push('/contatto-edit/')
      },
      rowAction (row,page) {
        console.log(row)
        this.$contatto.row = row
          this.$router.push('/'+page)
      },
      rowDel (row) {
         this.$confirm('L\'utente '+row.cognome+' verrà eliminato, continuare?', 'Warning', {
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
            type: 'warning'
         }).then(async () => {
            await this.$axios.deleteRow(row.id,'contatto')
            this.$centro.init()
         }).catch(() => {
            this.$message({
               type: 'info',
               message: 'Operazione annullata'
            })         
         })
         
      },
      handleCurrentChange(val) {
         this.tbstart = val*totxpage-totxpage      
         console.log(`current page: ${val}`);
      },
      onSelect(row, event, column){
         this.more=row.id
      },
      onSort(column,event){
         console.log(column)
         this.order = (this.order=='desc') ? 'asc' :'desc'
         this.icon = (this.order=='desc') ? 'el-icon-sort-down' :'el-icon-sort-up'
         this.dbData.sort(this.$teras.compareValues(column.property,this.order))
      },
      labelCol(h, {column}){
         return h('div',{ style: 'color:red;' },[h('b',null,column.label),h('i',{class:this.icon})])
      } 
    
  }
}
</script>


<style scoped>

</style>
